(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1786],{

/***/ 33730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 74152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 75125:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vote",
      function () {
        return __webpack_require__(17070);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SkeletonV2; },
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/types.ts
var types_animation = {
    WAVES: "waves",
    PULSE: "pulse"
};
var types_variant = {
    RECT: "rect",
    CIRCLE: "circle"
};

// EXTERNAL MODULE: ./packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(98903);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   from {\n        left: -150px;\n    }\n    to   {\n        left: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  will-change: opacity;\n  opacity: 0;\n  &.appear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n  &.disappear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 20px;\n  display: block;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 2s infinite ease-out;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n  &:before {\n    content: "";\n    position: absolute;\n    background-image: linear-gradient(90deg, transparent, rgba(243, 243, 243, 0.5), transparent);\n    top: 0;\n    left: -150px;\n    height: 100%;\n    width: 150px;\n    animation: ',
        " 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var waves = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var AnimationWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-94de765-0"
}).withConfig({
    componentId: "sc-bfc8af08-0"
})(_templateObject2(), animationToolkit/* appearAnimation */.Oz, animationToolkit/* disappearAnimation */.a4);
var SkeletonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-1"
}).withConfig({
    componentId: "sc-bfc8af08-1"
})(_templateObject3(), index_esm/* layout */.bK, index_esm/* space */.Dh);
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-2"
}).withConfig({
    componentId: "sc-bfc8af08-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === types_variant.CIRCLE ? theme.radii.circle : theme.radii.small;
}, index_esm/* layout */.bK, index_esm/* space */.Dh, index_esm/* borderRadius */.E0);
var Pulse = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-3"
}).withConfig({
    componentId: "sc-bfc8af08-3"
})(_templateObject5(), pulse);
var Waves = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-4"
}).withConfig({
    componentId: "sc-bfc8af08-4"
})(_templateObject6(), waves);
var Skeleton = function Skeleton(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation"
    ]);
    if (animation === types_animation.WAVES) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread/* default */.Z)({
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread/* default */.Z)({
        variant: variant
    }, props));
};
var SkeletonV2 = function SkeletonV2(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, _isDataReady = _param.isDataReady, isDataReady = _isDataReady === void 0 ? false : _isDataReady, children = _param.children, wrapperProps = _param.wrapperProps, _skeletonTop = _param.skeletonTop, skeletonTop = _skeletonTop === void 0 ? "0" : _skeletonTop, _skeletonLeft = _param.skeletonLeft, skeletonLeft = _skeletonLeft === void 0 ? "0" : _skeletonLeft, width = _param.width, height = _param.height, mr = _param.mr, ml = _param.ml, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation",
        "isDataReady",
        "children",
        "wrapperProps",
        "skeletonTop",
        "skeletonLeft",
        "width",
        "height",
        "mr",
        "ml"
    ]);
    var animationRef = (0,react.useRef)(null);
    var skeletonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width,
        height: height,
        mr: mr,
        ml: ml
    }, wrapperProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
            features: features_animation/* domAnimation */.H,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
                children: [
                    isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: animationRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(animationRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: children
                    }), "content"),
                    !isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        style: {
                            position: "absolute",
                            top: skeletonTop,
                            left: skeletonLeft
                        },
                        ref: skeletonRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(skeletonRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: animation === types_animation.WAVES ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        }))
                    }), "skeleton")
                ]
            })
        })
    }));
};
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);


/***/ }),

/***/ 74116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTooltip_useTooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(95237);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./packages/uikit/src/theme/light.ts
var light = __webpack_require__(93723);
// EXTERNAL MODULE: ./packages/uikit/src/theme/dark.ts
var dark = __webpack_require__(4409);
// EXTERNAL MODULE: ./packages/uikit/src/util/getPortalRoot.ts
var getPortalRoot = __webpack_require__(77382);
;// CONCATENATED MODULE: ./packages/uikit/src/util/isTouchDevice.ts
var isTouchDevice = function isTouchDevice() {
    return  true && ("ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-ignore
    navigator.msMaxTouchPoints > 0);
};
/* harmony default export */ var util_isTouchDevice = (isTouchDevice);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/StyledTooltip.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  &,\n  &::before {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    z-index: -1;\n  }\n\n  &::before {\n    content: "";\n    transform: rotate(45deg);\n    background: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  font-size: 14px;\n  line-height: 150%;\n  border-radius: 16px;\n  max-width: 320px;\n  z-index: 101;\n  background: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ';\n  white-space: pre-line;\n  &[data-popper-placement^="top"] > ',
        ' {\n    bottom: -4px;\n  }\n\n  &[data-popper-placement^="bottom"] > ',
        ' {\n    top: -4px;\n  }\n\n  &[data-popper-placement^="left"] > ',
        ' {\n    right: -4px;\n  }\n\n  &[data-popper-placement^="right"] > ',
        " {\n    left: -4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cfe0fd96-0"
}).withConfig({
    componentId: "sc-345c868b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
});
var StyledTooltip = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-cfe0fd96-1"
}).withConfig({
    componentId: "sc-345c868b-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.text;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, Arrow, Arrow, Arrow, Arrow);

;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx













var animationVariants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};
var animationMap = {
    initial: "initial",
    animate: "animate",
    exit: "exit"
};
var invertTheme = function invertTheme(currentTheme) {
    if (currentTheme.isDark) {
        return light/* default */.Z;
    }
    return dark/* default */.Z;
};
var useTooltip = function useTooltip(content, options) {
    var _placement = options.placement, placement = _placement === void 0 ? "auto" : _placement, _trigger = options.trigger, trigger = _trigger === void 0 ? "hover" : _trigger, _arrowPadding = options.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 16 : _arrowPadding, _tooltipPadding = options.tooltipPadding, tooltipPadding = _tooltipPadding === void 0 ? {
        left: 16,
        right: 16
    } : _tooltipPadding, _tooltipOffset = options.tooltipOffset, tooltipOffset = _tooltipOffset === void 0 ? [
        0,
        10
    ] : _tooltipOffset, _hideTimeout = options.hideTimeout, hideTimeout = _hideTimeout === void 0 ? 100 : _hideTimeout;
    var ref = (0,react.useState)(null), targetElement = ref[0], setTargetElement = ref[1];
    var ref1 = (0,react.useState)(null), tooltipElement = ref1[0], setTooltipElement = ref1[1];
    var ref2 = (0,react.useState)(null), arrowElement = ref2[0], setArrowElement = ref2[1];
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var isHoveringOverTooltip = (0,react.useRef)(false);
    var hideTimeoutRef = (0,react.useRef)();
    var hideTooltip = (0,react.useCallback)(function(e) {
        var hide = function hide() {
            e.stopPropagation();
            e.preventDefault();
            setVisible(false);
        };
        if (trigger === "hover") {
            if (hideTimeoutRef.current) {
                window.clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = false;
            }
            if (!isHoveringOverTooltip.current) {
                hideTimeoutRef.current = window.setTimeout(function() {
                    if (!isHoveringOverTooltip.current) {
                        hide();
                    }
                }, hideTimeout);
            }
        } else {
            hide();
        }
    }, [
        tooltipElement,
        trigger,
        hideTimeout
    ]);
    var showTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        e.preventDefault();
        setVisible(true);
        if (trigger === "hover") {
            if (e.target === targetElement) {
                // If we were about to close the tooltip and got back to it
                // then prevent closing it.
                clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = true;
            }
        }
    }, [
        tooltipElement,
        targetElement,
        trigger
    ]);
    var toggleTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setVisible(!visible);
    }, [
        visible
    ]);
    // Trigger = hover
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "hover") return undefined;
        if (util_isTouchDevice()) {
            targetElement.addEventListener("touchstart", showTooltip);
            targetElement.addEventListener("touchend", hideTooltip);
        } else {
            targetElement.addEventListener("mouseenter", showTooltip);
            targetElement.addEventListener("mouseleave", hideTooltip);
        }
        return function() {
            targetElement.removeEventListener("touchstart", showTooltip);
            targetElement.removeEventListener("touchend", hideTooltip);
            targetElement.removeEventListener("mouseenter", showTooltip);
            targetElement.removeEventListener("mouseleave", showTooltip);
        };
    }, [
        trigger,
        targetElement,
        hideTooltip,
        showTooltip
    ]);
    // Keep tooltip open when cursor moves from the targetElement to the tooltip
    (0,react.useEffect)(function() {
        if (tooltipElement === null || trigger !== "hover") return undefined;
        tooltipElement.addEventListener("mouseenter", showTooltip);
        tooltipElement.addEventListener("mouseleave", hideTooltip);
        return function() {
            tooltipElement.removeEventListener("mouseenter", showTooltip);
            tooltipElement.removeEventListener("mouseleave", hideTooltip);
        };
    }, [
        trigger,
        tooltipElement,
        hideTooltip,
        showTooltip
    ]);
    // Trigger = click
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "click") return undefined;
        targetElement.addEventListener("click", toggleTooltip);
        return function() {
            return targetElement.removeEventListener("click", toggleTooltip);
        };
    }, [
        trigger,
        targetElement,
        visible,
        toggleTooltip
    ]);
    // Handle click outside
    (0,react.useEffect)(function() {
        if (trigger !== "click") return undefined;
        var handleClickOutside = function handleClickOutside(param) {
            var target = param.target;
            if ((0,_instanceof/* default */.Z)(target, Node)) {
                if (tooltipElement != null && targetElement != null && !tooltipElement.contains(target) && !targetElement.contains(target)) {
                    setVisible(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        trigger,
        targetElement,
        tooltipElement
    ]);
    // Trigger = focus
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "focus") return undefined;
        targetElement.addEventListener("focus", showTooltip);
        targetElement.addEventListener("blur", hideTooltip);
        return function() {
            targetElement.removeEventListener("focus", showTooltip);
            targetElement.removeEventListener("blur", hideTooltip);
        };
    }, [
        trigger,
        targetElement,
        showTooltip,
        hideTooltip
    ]);
    // On small screens Popper.js tries to squeeze the tooltip to available space without overflowing beyond the edge
    // of the screen. While it works fine when the element is in the middle of the screen it does not handle well the
    // cases when the target element is very close to the edge of the screen - no margin is applied between the tooltip
    // and the screen edge.
    // preventOverflow mitigates this behaviour, default 16px paddings on left and right solve the problem for all screen sizes
    // that we support.
    // Note that in the farm page where there are tooltips very close to the edge of the screen this padding works perfectly
    // even on the iPhone 5 screen (320px wide), BUT in the storybook with the contrived example ScreenEdges example
    // iPhone 5 behaves differently overflowing beyond the edge. All paddings are identical so I have no idea why it is,
    // and fixing that seems like a very bad use of time.
    var ref4 = (0,usePopper/* usePopper */.D)(targetElement, tooltipElement, {
        placement: placement,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: arrowPadding
                }
            },
            {
                name: "offset",
                options: {
                    offset: tooltipOffset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: tooltipPadding
                }
            }, 
        ]
    }), styles = ref4.styles, attributes = ref4.attributes;
    var tooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationMap), {
        variants: animationVariants,
        transition: {
            duration: 0.3
        },
        ref: setTooltipElement,
        style: styles.popper
    }), attributes.popper), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: invertTheme,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                ref: setArrowElement,
                style: styles.arrow
            })
        ]
    }));
    var AnimatedTooltip = /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: visible && tooltip
        })
    });
    var portal = (0,getPortalRoot/* default */.Z)();
    var tooltipInPortal = portal ? /*#__PURE__*/ (0,react_dom.createPortal)(AnimatedTooltip, portal) : null;
    return {
        targetRef: setTargetElement,
        tooltip: tooltipInPortal !== null && tooltipInPortal !== void 0 ? tooltipInPortal : AnimatedTooltip,
        tooltipVisible: visible
    };
};
/* harmony default export */ var useTooltip_useTooltip = (useTooltip);


/***/ }),

/***/ 41914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tz": function() { return /* binding */ AutoColumn; },
/* harmony export */   "lg": function() { return /* binding */ ColumnCenter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94589);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: ",
        ";\n  justify-items: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Column = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-0"
})(_templateObject());
var ColumnCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Column).withConfig({
    componentId: "sc-91e5cc43-1"
})(_templateObject1());
var AutoColumn = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-2"
})(_templateObject2(), function(param) {
    var gap = param.gap;
    return gap === "sm" && "8px" || gap === "md" && "12px" || gap === "lg" && "24px" || gap;
}, function(param) {
    var justify = param.justify;
    return justify;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Column);


/***/ }),

/***/ 45061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74116);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44850);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62276);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* eslint-disable */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  :hover,\n  :focus {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c32a5c15-0"
})(_templateObject());
var IconImg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-c32a5c15-1"
})(_templateObject1());
var QuestionHelper = function(_param) {
    var text = _param.text, _placement = _param.placement, placement = _placement === void 0 ? "right-end" : _placement, _size = _param.size, size = _size === void 0 ? "16px" : _size, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "placement",
        "size",
        "type"
    ]);
    var ref = (0,_noahswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(text, {
        placement: placement
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionWrapper, {
                ref: targetRef,
                children: type === "info" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconImg, {
                    src: "/images/all/info.png",
                    alt: ""
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: "textSubtle",
                    width: size
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionHelper);


/***/ }),

/***/ 28393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports ModalHeader, ModalBody */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4318);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9355);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5527);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97114);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25349);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44850);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92510);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80421);
/* harmony import */ var _noahswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65208);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64011);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94589);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41914);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93293);
/* harmony import */ var state_transactions_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55892);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 40px 24px 60px;\n  justify-content: center;\n  flex-direction: column;\n  img {\n    display: inline-block;\n    margin: 0 auto 25px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* padding-top: 20px; */\n  width: 100%;\n  min-width: 320px;\n  max-width: 420px !important;\n  padding-bottom: 80px;\n  word-break: break-word;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px 0 24px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var ModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f58e09a2-0"
})(_templateObject());
var ModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f58e09a2-1"
})(_templateObject1());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f58e09a2-2"
})(_templateObject2());
var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz).withConfig({
    componentId: "sc-f58e09a2-3"
})(_templateObject3());
var ConfirmedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .ColumnCenter */ .lg).withConfig({
    componentId: "sc-f58e09a2-4"
})(_templateObject4());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText, onDismiss = param.onDismiss;
    var t = (0,_noahswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ModalHeader, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* .ModalTitle */ .r6, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        variant: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: "/images/small-img/dengdai.png",
                    width: 68,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        fontSize: "20px",
                        children: t("noah405")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            color: "#85868A",
                            children: pendingText
                        })
                    })
                ]
            })
        ]
    });
}
var ResultModal = function(param) {
    var attemptingTxn = param.attemptingTxn, hash = param.hash, pendingText = param.pendingText, errorMessage = param.errorMessage, onDismiss = param.onDismiss, isBridgeEOS = param.isBridgeEOS, _successText = param.successText, successText = _successText === void 0 ? "质押成功" : _successText, _failText = param.failText, failText = _failText === void 0 ? "质押失败" : _failText, isSuccess = param.isSuccess, clearInput = param.clearInput;
    var ref = (0,state_transactions_hooks__WEBPACK_IMPORTED_MODULE_6__/* .usePendingTransactions */ .VQ)(), hasPendingTransactions = ref.hasPendingTransactions, pendingNumber = ref.pendingNumber, receipt = ref.receipt;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("default"), userMenuVariable = ref1[0], setUserMenuVariable = ref1[1];
    var isMobile = (0,_noahswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().isMobile;
    var t = (0,_noahswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (hasPendingTransactions) {
            setUserMenuVariable("pending");
        } else {
            setUserMenuVariable("default");
        }
    }, [
        hasPendingTransactions,
        pendingNumber,
        t
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if ((receipt === null || receipt === void 0 ? void 0 : receipt.status) === 1) {
            isSuccess();
        }
    }, [
        receipt
    ]);
    if (isBridgeEOS) {
        receipt.status = 1;
    }
    var contTitle = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        if (hash && userMenuVariable === "pending") {
            return t("noah406");
        }
        if (hash && receipt && (receipt === null || receipt === void 0 ? void 0 : receipt.status) === 1) {
            return successText;
        }
        return failText;
    }, [
        userMenuVariable,
        hash
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* .ModalContainer */ .F0, {
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: "auto",
        style: {
            overflow: "initial"
        },
        children: attemptingTxn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText,
            onDismiss: onDismiss
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            style: {
                width: isMobile ? "100% " : "418px",
                height: "auto"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* .ModalTitle */ .r6, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "text",
                            onClick: function() {
                                onDismiss();
                                if (clearInput && hash) {
                                    clearInput();
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                width: "24px",
                                color: "#000"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ModalBody, {
                    children: [
                        hash && userMenuVariable === "pending" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: "/images/small-img/tijiao.png",
                            width: 68,
                            alt: ""
                        }) : hash && (receipt === null || receipt === void 0 ? void 0 : receipt.status) === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: "/images/small-img/zhengque.png",
                            width: 68,
                            alt: ""
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: "/images/small-img/cuowu.png",
                            width: 68,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                fontSize: "24px",
                                fontWeight: "600",
                                children: contTitle
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            mb: "30px",
                            style: {
                                width: "100%"
                            },
                            children: hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                style: {
                                    width: "100%"
                                },
                                children: [
                                    (receipt === null || receipt === void 0 ? void 0 : receipt.status) !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        fontSize: "16px",
                                        mt: "5px",
                                        mb: "5px",
                                        color: "#85868A",
                                        children: pendingText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        external: true,
                                        href: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .getBlockExploreLink */ .C)(hash, "transaction", chainId),
                                        color: "#000",
                                        style: {
                                            background: "transparent",
                                            border: "1px solid #E8E8E8",
                                            padding: "10px 10px",
                                            borderRadius: "10px",
                                            width: !isMobile ? "380px" : "90%",
                                            textAlign: "center",
                                            display: "inline-block",
                                            marginTop: "20px"
                                        },
                                        children: t("noah6")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                style: {
                                    width: isMobile ? "100% " : "418px",
                                    height: "200px",
                                    fontSize: "14px",
                                    color: "#999",
                                    wordBreak: "break-all",
                                    textAlign: "center",
                                    padding: "20px",
                                    overflow: "auto"
                                },
                                children: errorMessage
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ResultModal);


/***/ }),

/***/ 17070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ vote; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(6260);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./src/utils/formatTimestamp.ts
var formatTimestamp = __webpack_require__(63257);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/hooks/useEagerConnect.bmp.ts + 2 modules
var useEagerConnect_bmp = __webpack_require__(71891);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(2688);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx + 1 modules
var CurrencyLogo = __webpack_require__(60764);
// EXTERNAL MODULE: ./src/components/ResultModal/index.tsx
var ResultModal = __webpack_require__(28393);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(61905);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(45061);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(42808);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(92510);
// EXTERNAL MODULE: ./src/views/Vote/style/all.module.scss
var all_module = __webpack_require__(53710);
var all_module_default = /*#__PURE__*/__webpack_require__.n(all_module);
;// CONCATENATED MODULE: ./src/views/Vote/components/AllLPModal.tsx
/* eslint-disable */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 19px;\n  font-size: 20px;\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  cursor: pointer;\n\n  &.active {\n    border-color: #000;\n    background: #ffe169;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c26e5ee4-0"
})(_templateObject());
var SelectBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c26e5ee4-1"
})(_templateObject1());
var AllLPModal = function(param) {
    var onDismiss = param.onDismiss, item = param.item;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // console.log('item', item)
    // const handleSetLanguage = (lang) => {
    //   setLanguage(lang)
    //   onDismiss()
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        title: t("noah182"),
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((all_module_default()).one, " flex flexc flexstart"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                    token0: item === null || item === void 0 ? void 0 : item.token0,
                                    token1: item === null || item === void 0 ? void 0 : item.token1,
                                    size: 30
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flexc",
                                    style: {
                                        marginLeft: "30px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((all_module_default()).symbol0Name),
                                        children: [
                                            item === null || item === void 0 ? void 0 : item.symbol0,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "".concat((all_module_default()).symbol1Name),
                                                children: [
                                                    "/",
                                                    item === null || item === void 0 ? void 0 : item.symbol1
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        variant: "text",
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            width: "24px",
                            color: "#000"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                p: "0 24px 24px 24px",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((all_module_default()).list),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((all_module_default()).twoBox, " flex flexcol"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((all_module_default()).test, " flex flexb"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((all_module_default()).label),
                                        children: t("noah324")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((all_module_default()).two, " flex flexcol flexjc"),
                                        children: (item === null || item === void 0 ? void 0 : item.fee_sharing.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: item === null || item === void 0 ? void 0 : item.fee_sharing.map(function(items, index_fee) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "",
                                                    children: (items === null || items === void 0 ? void 0 : items.quantity) != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            (0,formatBalance/* truncateZero */.bW)(items === null || items === void 0 ? void 0 : items.quantity, 4),
                                                            " ",
                                                            items.symbol
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: index_fee == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "-"
                                                        })
                                                    })
                                                }, index_fee);
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "-"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((all_module_default()).test, " flex flexb"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((all_module_default()).label),
                                        children: t("noah325")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((all_module_default()).two, " "),
                                        children: (item === null || item === void 0 ? void 0 : item.bribeList.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: item === null || item === void 0 ? void 0 : item.bribeList.map(function(items, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            (0,formatBalance/* formatEffectiveNumber */.bd)(items === null || items === void 0 ? void 0 : items.quantity),
                                                            " ",
                                                            items.symbol
                                                        ]
                                                    })
                                                });
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "-"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_AllLPModal = (AllLPModal);

// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
;// CONCATENATED MODULE: ./src/views/Vote/components/VoteModal.tsx
/* eslint-disable */ 


function VoteModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    VoteModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VoteModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 19px;\n  font-size: 20px;\n  border: 1px solid #eeeeee;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  cursor: pointer;\n\n  &.active {\n    border-color: #000;\n    background: #ffe169;\n  }\n"
    ]);
    VoteModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var VoteModal_ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bb27c3e-0"
})(VoteModal_templateObject());
var VoteModal_SelectBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4bb27c3e-1"
})(VoteModal_templateObject1());
var VoteModal = function(param) {
    var onDismiss = param.onDismiss, voteList = param.voteList, handleGoVote = param.handleGoVote;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // console.log('arr', voteList)
    var handleVote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // 告诉父组件要执行handleGoVote事件了
                handleGoVote();
                return [
                    2
                ];
            });
        });
        return function handleVote() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        title: t("noah182"),
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: "auto",
        style: {
            width: "300px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VoteModal_ModalHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: t("noah368")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        variant: "text",
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            width: "24px",
                            color: "#000"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "0 24px 24px 24px",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((all_module_default()).tips),
                        children: t("noah422")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((all_module_default()).list2),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((all_module_default()).tit, " flexb"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("noah286"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("noah363")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (all_module_default()).box,
                                children: (voteList === null || voteList === void 0 ? void 0 : voteList.votedItems.length) > 0 ? voteList.votedItems.map(function(item, index) {
                                    var symbolChange = {
                                        token0: {
                                            name: item.name0,
                                            symbol: item.symbol0,
                                            address: item.contract0
                                        },
                                        token1: {
                                            name: item.name1,
                                            symbol: item.symbol1,
                                            address: item.contract1
                                        }
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: voteList.votes[item.id] && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "".concat((all_module_default()).item, " flexb"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat((all_module_default()).one, " flex flexc flexstart"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                            token0: symbolChange.token0,
                                                            token1: symbolChange.token1,
                                                            size: 25
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex flexc",
                                                            style: {
                                                                marginLeft: "20px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((all_module_default()).symbol0Name),
                                                                children: [
                                                                    item.symbol0,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "".concat((all_module_default()).symbol1Name),
                                                                        children: [
                                                                            "/",
                                                                            item.symbol1
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (all_module_default()).rate,
                                                    children: [
                                                        voteList.votes[item.id],
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index);
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "no_data",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/claim/nodata.png",
                                            alt: "",
                                            style: {
                                                width: "70px",
                                                height: "50px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: "18px",
                                            color: "#85868A",
                                            mb: "20px",
                                            mt: "12px",
                                            children: t("noah338")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (all_module_default()).details,
                        children: [
                            t("noah365"),
                            ": ",
                            voteList.totalVotes,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (all_module_default()).btn,
                        onClick: function() {
                            handleVote();
                        },
                        children: t("noah368")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_VoteModal = (VoteModal);

// EXTERNAL MODULE: ./src/views/Vote/style/index.module.scss
var index_module = __webpack_require__(81528);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/views/Vote/components/ResetModal.tsx
/* eslint-disable */ 
function ResetModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 12px 24px;\n"
    ]);
    ResetModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ResetModal_ModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e828943-0"
})(ResetModal_templateObject());
var ResetModal = function(param) {
    var onDismiss = param.onDismiss, reset = param.reset;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    console.log("reset modal", reset);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        title: t(""),
        $minWidth: isMobile ? "100%" : "418px",
        $minHeight: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResetModal_ModalHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: t("noah607")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        variant: "text",
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            width: "24px",
                            color: "#000"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                p: "0 24px 24px 24px",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        lineHeight: "18px",
                        fontSize: "14px"
                    },
                    children: t(reset === 0 ? "noah606" : "noah608")
                })
            })
        ]
    });
};
/* harmony default export */ var components_ResetModal = (ResetModal);

;// CONCATENATED MODULE: ./src/views/Vote/index.tsx
/* eslint-disable */ 






function Vote_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-gap: 1em;\n    align-items: center;\n    // grid-template-columns: repeat(6, 2fr);\n    grid-template-columns: 18% 16% 18% 18% 10% auto;\n    background: ",
        ";\n    margin-top: ",
        ";\n    border-radius: ",
        ";\n    text-align: center;\n    grid-template-columns::nth-child(1) {\n      border: 1px solid red;\n    }\n    // padding: 0 24px;\n    @media screen and (max-width: 1200px) {\n      padding: 0 20px;\n      // grid-template-columns: 200px 1.5fr repeat(3, 2fr);\n      grid-template-columns: 35% 30% 31%;\n      & :nth-child(4),\n      & :nth-child(5),\n      & :nth-child(6) {\n        display: none;\n      }\n    }\n    @media screen and (max-width: 500px) {\n      padding: 0 20px;\n      grid-template-columns: 35% 30% 25% !important;\n      & :nth-child(4),\n      & :nth-child(5),\n      & :nth-child(6) {\n        display: none;\n      }\n    }\n    // @media screen and (max-width: 480px) {\n    //   grid-template-columns: 2.5fr repeat(1, 1fr);\n    //   > *:nth-child(1) {\n    //     display: none;\n    //   }\n    // }\n  "
    ]);
    Vote_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Vote_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    right: 5px;\n    top: 12px;\n    transform: ",
        ";\n    height: 25px;\n    width: 25px;\n  "
    ]);
    Vote_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

 // eslint-line



// @ts-ignore
// eslint-disable-next-line import/extensions









// import { Updater } from 'state/transactions/updater'













// import { ALLOWED_PATHS } from 'config/index'
// import { DEFAULT_CHAINID } from 'config'
var deepEqual = function(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(var i = 0; i < arr1.length; i++){
        if (arr1[i].id !== arr2[i].id) return false;
    }
    return true;
};
function Vote() {
    var router = (0,next_router.useRouter)();
    var ref = (0,useActiveWeb3React/* default */.Z)(), provider = ref.provider, chainId = ref.chainId;
    // useEffect(() => {
    // console.log('router', router.pathname, chainId)
    // if(chainId == DEFAULT_CHAINID && !ALLOWED_PATHS.includes(router.pathname)){
    //   console.log('不存在的路由')
    //   router.replace(`/404`)
    //   // router.push(`/404`)
    //   return null
    // }
    // }, [router.pathname, chainId]);
    var handleActive = (0,useEagerConnect_bmp/* useActiveHandle */.v0)();
    var onPresentConnectModal = (0,useWallet/* useWallet */.O)().onPresentConnectModal;
    // const { provider, chainId } = useActiveWeb3React()
    // 农场
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    // console.log(testa, 'testa')
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    // const router = useRouter()
    var account = (0,src/* useWeb3React */.Ge)().account;
    // console.log(chainId, 'chainId')
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref1 = (0,react.useState)(null), nowep = ref1[0], setNowEP = ref1[1];
    var ref2 = (0,react.useState)(null), startTime = ref2[0], setStartTime = ref2[1];
    var ref3 = (0,react.useState)(null), endTime = ref3[0], setEndTime = ref3[1];
    var ref4 = (0,react.useState)(""), searchValue = ref4[0], setSearchValue = ref4[1];
    var ref5 = (0,react.useState)(false), showPanel = ref5[0], setShowPanel = ref5[1];
    var ref6 = (0,react.useState)("0.00"), staked = ref6[0], setStaked = ref6[1];
    var ref7 = (0,react.useState)("0.00"), amount = ref7[0], setAmount = ref7[1];
    var ref8 = (0,react.useState)("0.0000"), myVotes = ref8[0], setMyVotes = ref8[1];
    var ref9 = (0,react.useState)("0"), epoch = ref9[0], setEpoch = ref9[1];
    var ref10 = (0,react.useState)("0"), epochAt = ref10[0], setEpochAt = ref10[1];
    var ref11 = (0,react.useState)("0"), lasteds = ref11[0], setLasteds = ref11[1];
    // const [finalVotes, setFinalVotes] = useState({})
    var ref12 // 需要传递的item, 当前
     = (0,react.useState)(null), symobj = ref12[0], setSymobj = ref12[1];
    var ref13 // 禁止投票
     = (0,react.useState)(true), noVotes = ref13[0], setNoVote = ref13[1];
    var ref14 // 本周已投过票
     = (0,react.useState)(false), week = ref14[0], setWeek = ref14[1];
    var ref15 // 0 --- 有池子已投票不允许reset 1---有池子未投票允许reset 2 --- 没池子未投票不允许reset
     = (0,react.useState)(0), reset = ref15[0], setReset = ref15[1];
    var ref16 = (0,react.useState)([]), list = ref16[0], setList = ref16[1];
    var VotingEscrowContract = (0,useContract/* useVotingEscrowContract */.$t)();
    var VoterContract = (0,useContract/* useVoterContract */.m4)();
    var MinterContract = (0,useContract/* useMinterContract */.jS)();
    // const parsedQueryChainId = Number(router.query.cha //inId)
    // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId'))
    var ref17 = (0,react.useState)(false), loading = ref17[0], setLoading = ref17[1];
    var ref18 = (0,react.useState)({
        votes: {},
        totalVotes: 0,
        votedItems: []
    }), state = ref18[0], setState = ref18[1];
    var ResponsiveGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-368ae5a4-0"
    })(Vote_templateObject(), function(param) {
        var tableHead = param.tableHead;
        return tableHead ? "#F2F2F2" : "#fff";
    }, function(param) {
        var tableHead = param.tableHead;
        return tableHead ? "10px" : "10px";
    }, function(param) {
        var tableHead = param.tableHead;
        return tableHead ? "8px" : "0px";
    });
    var LoadingRow = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveGrid, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
            ]
        });
    };
    var TableLoader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {})
            ]
        });
    };
    // console.log(VoterContract, 'VoterContract')
    // console.log(VotingEscrowContract, 'VotingEscrowContract')
    // console.log(MinterContract, 'MinterContract')
    var openModalWithItem = function(item) {
        setSymobj(item);
        onPresentAllLPModal();
    };
    var getDataStart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var supply, bb, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            VotingEscrowContract.supply() // 质押量
                        ];
                    case 1:
                        supply = _state.sent();
                        return [
                            4,
                            VoterContract.totalWeight() // 投票数量
                        ];
                    case 2:
                        bb = _state.sent();
                        // const cepoch = await MinterContract.epoch() // 查询当前所在期数(纪元)
                        setStaked((0,formatBalance/* formatBigNumberToFixed */.U1)(supply || 0, 2));
                        setAmount((0,formatBalance/* formatBigNumberToFixed */.U1)(bb || 0, 2));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getDataStart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!VotingEscrowContract && !VoterContract) return;
        getDataStart();
        getData(account);
    }, [
        account,
        VotingEscrowContract,
        VoterContract
    ]);
    (0,react.useEffect)(function() {
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        var env = "production";
        // console.log(env, baseURL, chainid)
        setLoading(true);
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, code, data, dataFormat, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,service/* getVotePools */.Zc)({
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), code = ref.code, data = ref.data;
                            // console.log(code, 'code')
                            if (!code) {
                                dataFormat = data === null || data === void 0 ? void 0 : data.map(function(current) {
                                    return (0,_object_spread/* default */.Z)({
                                        token0: {
                                            address: current.contract0,
                                            symbol: current.symbol0
                                        },
                                        token1: {
                                            address: current.contract1,
                                            symbol: current.symbol1
                                        }
                                    }, current);
                                });
                                // console.log(dataFormat, 'dataFormat')
                                // let test = [...dataFormat, ...dataFormat, ...dataFormat]
                                setList(dataFormat);
                            // setLoading(false)
                            } else {
                                setLoading(false);
                                setList([]);
                            // setDefaultFetchState([])
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            setList([]);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        // if (!chainId) return
        fetch();
    }, []);
    var getData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(account) {
            var combined, myvotes, usedWeights, lasted, epochAt, userVotes, idMap, two, three, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        combined = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            VotingEscrowContract.balanceOf(account) // 我的票数
                        ];
                    case 2:
                        myvotes = _state.sent();
                        return [
                            4,
                            VoterContract.usedWeights(account) // 总权重
                        ];
                    case 3:
                        usedWeights = _state.sent();
                        return [
                            4,
                            VoterContract.lastVoted(account) // 最后一次投票时间戳
                        ];
                    case 4:
                        lasted = _state.sent();
                        return [
                            4,
                            MinterContract.epochAt(lasted.toString()) // 查询传的时间戳所在期数
                        ];
                    case 5:
                        epochAt = _state.sent();
                        return [
                            4,
                            VoterContract["userVotes(address)"](account) // 批量查询用户投票数据
                        ];
                    case 6:
                        userVotes = _state.sent();
                        setMyVotes((0,formatBalance/* formatBigNumberToFixed */.U1)(myvotes || 0));
                        // console.log('合约返回的总权重', formatBigNumberToFixed(usedWeights || 0))
                        // console.log('userVotes', userVotes)
                        // 0 --- 有池子已投票不允许reset 1---有池子未投票允许reset 2 --- 没池子不允许reset
                        if (userVotes._pools.length > 0) {
                            if (week) {
                                setReset(0) // 本记元已投票，无取消投票
                                ;
                            } else {
                                setReset(1) // 可投票，可取消投票
                                ;
                            }
                        } else {
                            if (week) {
                                setReset(2) // 本记元已取消投票，无取消投票
                                ;
                            } else {
                                setReset(3) // 可投票，无取消投票
                                ;
                            }
                        }
                        if (userVotes._pools.length > 0 && userVotes._votes.length > 0) {
                            combined = userVotes._pools.map(function(pool, index) {
                                // 这里需要每个池子除以我的票数得出占比=======================================================================
                                // console.log('合约返回的我的票数-' + index, formatBigNumberToFixed(userVotes._votes[index]))
                                var voteVal = Math.round(Number((0,formatBalance/* formatBigNumberToFixed */.U1)(userVotes._votes[index] || 0)) / Number((0,formatBalance/* formatBigNumberToFixed */.U1)(usedWeights || 0)) * 100);
                                if (userVotes._votes[index].toString() == 0 && usedWeights == 0) {
                                    voteVal = 0;
                                }
                                return {
                                    pool: pool,
                                    vote: voteVal
                                };
                            });
                        }
                        idMap = {};
                        list.forEach(function(item) {
                            idMap[item.pair_id] = item.id;
                        });
                        // console.l
                        // console.log(combined, 'combined================================')
                        combined.forEach(function(item) {
                            var id = idMap[item.pool];
                            if (id !== undefined) {
                                votes[id] = item.vote;
                            } else {
                                votes[id] = 0;
                            }
                        });
                        two = Object.values(votes).reduce(function(a, b) {
                            return a + b;
                        }, 0);
                        three = list.filter(function(item) {
                            return votes[item.id] !== 0;
                        }).map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                votes: votes[item.id]
                            });
                        });
                        setState({
                            // 拿到的批量数据更新
                            votes: votes,
                            // votes: {1: 20, 2: 40},
                            totalVotes: two,
                            votedItems: three
                        });
                        // console.log('我的票数', formatBigNumberToFixed(myvotes || 0))
                        // console.log('总权重', usedWeights.toString())
                        // console.log('最后一次投票时间戳', lasted.toString())
                        // console.log('上一次投票所在期数', epochAt.toString())
                        // console.log('当前所在期数', epoch)
                        // console.log('批量查询', userVotes)
                        // console.log('投票数据', combined)
                        setLasteds(lasted.toString());
                        setEpochAt(epochAt.toString());
                        setLoading(false);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        console.log();
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function getData(account) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        // console.log('最后一次投票时间戳', lasteds.toString())
        // console.log('上一次投票所在期数', epochAt.toString())
        // console.log('当前所在期数', epoch)
        if (lasteds.toString() == "0" || epoch != epochAt.toString()) {
            setWeek(false);
            setNoVote(false) // 为false, 可以投票
            ;
        } else {
            // console.log('@@@@@@@@@@@@已经投过票')
            setWeek(true);
            setNoVote(true) // 为true, 禁止投票
            ;
        // console.log('@@@@@@@@@@@@已经投过票@@@@@@@@@@@')
        }
    }, [
        lasteds,
        epoch,
        epochAt,
        account
    ]);
    // useEffect(() => {
    //   console.log('reset', reset)
    // },[reset])
    (0,react.useEffect)(function() {
        if (!account) {
            setMyVotes("0.0000");
            setLoading(false);
        // getDataStart()
        }
        // console.log('执行1111')
        if (!account && !VotingEscrowContract && !VoterContract && !MinterContract) return;
        // console.log('执行2222')
        getData(account);
    }, [
        account,
        list,
        VotingEscrowContract,
        VoterContract,
        MinterContract,
        week
    ]);
    (0,react.useEffect)(function() {
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        var epochs = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, code, data, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,service/* getEpoch */.R5)({
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), code = ref.code, data = ref.data;
                            if (!code) {
                                // console.log(data)
                                setEpoch(data.epoch);
                                setStartTime(data.startTime);
                                setEndTime(data.endTime);
                            } else {}
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            console.log(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function epochs() {
                return _ref.apply(this, arguments);
            };
        }();
        epochs();
    }, []);
    // const list = [
    //   {
    //     symbol0: 'BNB',
    //     symbol1: 'EOS',
    //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
    //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
    //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
    //     name0: 'Binance',
    //     name1: 'Wrapped EOS',
    //     towVal: '39783767.89',
    //     twoRate: '10.89%',
    //     threeVal: '83767.89',
    //     threeUs: '$ 783,767.89',
    //     baseRate: '3767.89',
    //     heightRate: '63767.89',
    //     allLP: '87.87%',
    //     id: 1,
    //   },
    //   {
    //     symbol0: 'BNB',
    //     symbol1: 'EOS',
    //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
    //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
    //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
    //     name0: 'Binance',
    //     name1: 'Wrapped EOS',
    //     towVal: '0',
    //     twoRate: '10.89%',
    //     threeVal: '0',
    //     threeUs: '$ 783,767.89',
    //     baseRate: '0',
    //     heightRate: '63,767.89 BCD',
    //     allLP: '0.00%',
    //     id: 2,
    //   },
    //   {
    //     symbol0: 'BNB',
    //     symbol1: 'EOS',
    //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
    //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
    //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
    //     name0: 'Binance',
    //     name1: 'Wrapped EOS',
    //     towVal: '0.0003',
    //     twoRate: '10.89%',
    //     threeVal: '0.0001',
    //     threeUs: '$ 783,767.89',
    //     baseRate: '3767.89',
    //     heightRate: '63767.89',
    //     allLP: '87.87%',
    //     id: 3,
    //   },
    //   {
    //     symbol0: 'BNB',
    //     symbol1: 'EOS',
    //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
    //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
    //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
    //     name0: 'Binance',
    //     name1: 'Wrapped EOS',
    //     towVal: '39783767.89',
    //     twoRate: '10.89%',
    //     threeVal: '83767.89',
    //     threeUs: '$ 783,767.89',
    //     baseRate: '3767.89',
    //     heightRate: '63767.89',
    //     allLP: '87.87%',
    //     id: 4,
    //   },
    //   {
    //     symbol0: 'BNB',
    //     symbol1: 'EOS',
    //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
    //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
    //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
    //     name0: 'Binance',
    //     name1: 'Wrapped EOS',
    //     towVal: '39783767.89',
    //     twoRate: '10.89%',
    //     threeVal: '83767.89',
    //     threeUs: '$ 783,767.89',
    //     baseRate: '3767.89',
    //     heightRate: '63767.89',
    //     allLP: '87.87%',
    //     id: 5,
    //   },
    //   {
    //     symbol0: 'BNB',
    //     symbol1: 'EOS',
    //     img0: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0xaf3738cdae9aa9e3dac27d5a5d9ee8f08cdea036-btc.png',
    //     img1: 'https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/15557-0x8fcd76769be5c4af087bf52fd4a27af9636425c4-bnb.png',
    //     contract0: '0x461d52769884ca6235b685ef2040f47d30c94eb5',
    //     contract1: '0xc00592aa41d32d137dc480d9f6d0df19b860104f',
    //     name0: 'Binance',
    //     name1: 'Wrapped EOS',
    //     towVal: '39783767.89',
    //     twoRate: '10.89%',
    //     threeVal: '83767.89',
    //     threeUs: '$ 783,767.89',
    //     baseRate: '3767.89',
    //     heightRate: '63767.89',
    //     allLP: '87.87%',
    //     id: 6,
    //   },
    // ]
    // const [votes, setVotes] = useState({}); // 存储每一项的投票数
    var previousDataRef = (0,react.useRef)(list);
    // const [votedItems, setVotedItems] = useState([]); // 存储已投票的项目
    // const [totalVotes, setTotalVotes] = useState(0); // 存储总票数
    var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronDown/* default */.Z).withConfig({
        componentId: "sc-368ae5a4-1"
    })(Vote_templateObject1(), function(param) {
        var toggled = param.toggled;
        return toggled ? "rotate(0deg)" : "rotate(180deg)";
    });
    var ref19 = (0,react.useState)({
        width: window.innerWidth
    }), windowSize = ref19[0], setWindowSize = ref19[1];
    // 弹窗 传值
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_AllLPModal, {
        item: symobj
    }), true, true, "allLpModal"), 1), onPresentAllLPModal = ref20[0];
    var ref21 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ResetModal, {
        reset: reset
    }), true, true, "resetModal"), 1), onPresentResetModal = ref21[0];
    // const [onPresentVoteModal] = useModal(
    // () => <VoteModal handleGoVote={handleGoVote} voteList={state} />,
    //   true,
    //   true,
    //   'voteModal'
    // );
    var rootRef = (0,react.useRef)(null);
    var ref22 = (0,react.useState)(0), contentHeight = ref22[0], setContentHeight = ref22[1];
    // modal and loading
    var ref23 = (0,react.useState)({
        attemptingTxn: false,
        pledgeErrorMessage: undefined,
        txHash: undefined
    }), ref24 = ref23[0], attemptingTxn = ref24.attemptingTxn, pledgeErrorMessage = ref24.pledgeErrorMessage, txHash = ref24.txHash, setVoteState = ref23[1];
    var pendingText = t("Vote in %epoch%", {
        epoch: "Epoch" + epoch
    });
    // 投票成功/投票失败
    var ref25 = (0,react.useState)({
        successText: t("noah378"),
        failText: t("noah379")
    }), ref26 = ref25[0], successText = ref26.successText, failText = ref26.failText, setText = ref25[1];
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ResultModal/* default */.ZP, {
        pendingText: pendingText,
        hash: txHash,
        attemptingTxn: attemptingTxn,
        errorMessage: pledgeErrorMessage,
        successText: successText,
        failText: failText,
        isSuccess: function() {
            // console.log('执行合约成功了')
            getDataStart();
            getData(account);
        }
    }), false, true, "ResultModal"), 1), onPVoteResultModal = ref27[0];
    (0,react.useEffect)(function() {
        setContentHeight(rootRef.current.offsetHeight);
    }, []);
    (0,react.useEffect)(function() {
        document.body.classList.add("fixed-body");
        return function() {
            document.body.classList.remove("fixed-body");
        };
    }, []);
    (0,react.useEffect)(function() {
        if (true) {
            var handleResize = function() {
                // clearTimeout(timeoutId);
                // timeoutId = setTimeout(() => {
                setWindowSize({
                    width: window.innerWidth
                });
            // }, 150);
            };
            // 在组件挂载后，添加 resize 事件监听器
            window.addEventListener("resize", handleResize);
            // 在组件卸载时，删除事件监听器
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, []);
    // 先留着吧
    // useEffect(() => {
    //   if (!deepEqual(list, previousDataRef.current)) {
    //     const initialVotes = {}
    //     list.forEach((item) => {
    //       initialVotes[item.id] = 0
    //     })
    //     setState({
    //       votes: initialVotes,
    //       totalVotes: 0,
    //       votedItems: [],
    //     })
    //     previousDataRef.current = list
    //   }
    // }, [list])
    // 计算票数
    var handleVote = function(item, increment) {
        setState(function(prevState) {
            // console.log('prevState', prevState)
            var newVotes = (0,_object_spread/* default */.Z)({}, prevState.votes);
            newVotes[item.id] = newVotes[item.id] || 0 // 如果 votes[id] 未定义，设置为 0
            ;
            // console.log('newVotes[item.id]', newVotes[item.id], increment)
            var oldVote = newVotes[item.id];
            newVotes[item.id] += increment ? 5 : -5;
            if (newVotes[item.id] < 0) {
                newVotes[item.id] = 0;
            }
            // console.log('prevState.totalVotes', prevState.totalVotes)
            // 更新投票的总数
            var newTotalVotes = prevState.totalVotes + (newVotes[item.id] - oldVote);
            // console.log('aaaa', newTotalVotes)
            if (newTotalVotes == 100) {
                setNoVote(false) // 为false, 可以投票
                ;
            } else {
                setNoVote(true) // 为true, 禁止投票
                ;
            }
            // 2023/6/25 注释================
            // if ((lasteds == '0' || epoch != epochAt) && newTotalVotes == 100) {
            //   setNoVote(false) // 为false, 可以投票
            // } else {
            //   setNoVote(true) // 为true, 禁止投票
            // }
            // 如果新的总投票数大于100，不更新状态
            if (newTotalVotes > 100) {
                return prevState;
            }
            var newVotedItems = (0,_to_consumable_array/* default */.Z)(prevState.votedItems);
            // 如果这个项目已经投票过，但新的投票数为 0，则从 votedItems 中移除它
            if (prevState.votedItems.find(function(votedItem) {
                return votedItem.id === item.id;
            }) && newVotes[item.id] === 0) {
                newVotedItems = prevState.votedItems.filter(function(votedItem) {
                    return votedItem.id !== item.id;
                });
            } else {
                // 如果这个项目已经投票过或新的投票数大于 0
                if (newVotes[item.id] > 0 || prevState.votedItems.find(function(votedItem) {
                    return votedItem.id === item.id;
                })) {
                    // 更新该项目的投票数
                    var updatedItem = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        votes: newVotes[item.id]
                    });
                    newVotedItems = newVotedItems.map(function(votedItem) {
                        return votedItem.id === item.id ? updatedItem : votedItem;
                    });
                    // 如果这个项目还没有投票过，添加到 votedItems 中
                    if (!prevState.votedItems.find(function(votedItem) {
                        return votedItem.id === item.id;
                    })) {
                        newVotedItems.push(updatedItem);
                    }
                }
            }
            return {
                votes: newVotes,
                totalVotes: newTotalVotes,
                votedItems: newVotedItems
            };
        });
    };
    var handleSearchValue = function(e) {
        setSearchValue(e.target.value);
    // console.log(searchValue)
    };
    var votes = state.votes, totalVotes = state.totalVotes, votedItems = state.votedItems;
    // console.log(votes, totalVotes, votedItems)
    // 执行投票合约
    var handleGoVote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newVoted, pairIds, votes, args, estimate, method;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (noVotes) return [
                            2
                        ];
                        newVoted = (0,_to_consumable_array/* default */.Z)(votedItems);
                        return [
                            4,
                            newVoted.filter(function(item) {
                                return item.votes !== undefined && item.votes !== 0;
                            })
                        ];
                    case 1:
                        newVoted = _state.sent();
                        pairIds = newVoted.map(function(item) {
                            return item.pair_id;
                        });
                        votes = newVoted.map(function(item) {
                            return item.votes * 10000;
                        });
                        // console.log('执行投票方法', pairIds, votes)
                        setVoteState({
                            attemptingTxn: true,
                            pledgeErrorMessage: undefined,
                            txHash: undefined
                        });
                        // console.log(attemptingTxn, 'setVoteState')
                        onPVoteResultModal();
                        args = [
                            pairIds,
                            votes
                        ];
                        estimate = VoterContract.estimateGas.vote;
                        method = VoterContract.vote;
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        // gasLimit: 2100000,
                                        gasPrice: gasPrice
                                    }
                                ])).then(function(response) {
                                    console.log("response", response);
                                    // 拿到交易hash
                                    var txHash = response.hash;
                                    // 设置定时器，每隔一定时间（这里设为5秒）检查一次交易状态
                                    // const intervalId = setInterval(() => {
                                    //   console.log('执行检查交易状态')
                                    //   provider
                                    //     .getTransactionReceipt(txHash)
                                    //     .then(receipt => {
                                    //       console.log(receipt, 'receipt')
                                    //       if (receipt && receipt.status) {
                                    //         // 如果交易成功，你可以在这里处理你的逻辑
                                    //         console.log("交易成功！");
                                    //         // 清除定时器
                                    //         clearInterval(intervalId);
                                    //       }
                                    //     })
                                    //     .catch(error => {
                                    //       console.error(`Failed to get transaction receipt: ${txHash}`, error);
                                    //     });
                                    // }, 500);
                                    setVoteState({
                                        attemptingTxn: false,
                                        pledgeErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                    addTransaction(response, {
                                        summary: "Vote",
                                        translatableSummary: {
                                            text: "noah366",
                                            data: {
                                                symbol: "Epoch ".concat(epoch)
                                            }
                                        },
                                        type: "Vote"
                                    });
                                });
                            }).catch(function(err) {
                                if (err && err.code !== 4001) {
                                    console.log(err);
                                    setVoteState({
                                        attemptingTxn: false,
                                        pledgeErrorMessage: err.message,
                                        txHash: undefined
                                    });
                                }
                                setVoteState({
                                    attemptingTxn: false,
                                    pledgeErrorMessage: err && err.code !== 4001 ? t("Vote failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGoVote() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_VoteModal, {
        handleGoVote: handleGoVote,
        voteList: state
    }), true, true, "voteModal"), 1), onPresentVoteModal = ref28[0];
    var handleClick = function() {
        if (typeof __NEZHA_BRIDGE__ !== "undefined") {
            handleActive();
        } else {
            onPresentConnectModal();
        }
    };
    var handleReset = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var estimate, method, args;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        estimate = VoterContract.estimateGas.reset;
                        method = VoterContract.reset;
                        args = [];
                        return [
                            4,
                            estimate.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(estimatedGasLimit) {
                                return method.apply(void 0, (0,_to_consumable_array/* default */.Z)(args).concat([
                                    {
                                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGasLimit),
                                        // gasLimit: 4000000,
                                        gasPrice: gasPrice
                                    }
                                ])).then(function(response) {
                                    getDataStart();
                                    getData(account);
                                    // console.log(response, 'responseresponse')
                                    setVoteState({
                                        attemptingTxn: false,
                                        pledgeErrorMessage: undefined,
                                        txHash: response.hash
                                    });
                                // addTransaction(response, {
                                //   summary: 'receive NOAH',
                                //   translatableSummary: {
                                //     text: `${t('noah260')} NOAH`,
                                //     data: {},
                                //   },
                                //   type: 'receive',
                                // })
                                });
                            }).catch(function(err) {
                                // console.log(err, 'errrrrr')
                                if (err && err.code !== 4001) {
                                    console.error("Receive failed", err);
                                    setVoteState({
                                        attemptingTxn: false,
                                        pledgeErrorMessage: err.message,
                                        txHash: undefined
                                    });
                                }
                                setVoteState({
                                    attemptingTxn: false,
                                    pledgeErrorMessage: err && err.code !== 4001 ? t("Receive failed: %message%", {
                                        message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(err, t)
                                    }) : undefined,
                                    txHash: undefined
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReset() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setWeek(false);
        setState({
            votes: {},
            totalVotes: 0,
            votedItems: []
        });
    }, [
        account
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: windowSize.width > 1200 ? (index_module_default()).bigBox : (index_module_default()).bigBox_small,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(windowSize.width < 1200 ? (index_module_default()).sm_farms : (index_module_default()).lg_farms, " ").concat((index_module_default()).box, " ").concat((index_module_default()).container),
            ref: rootRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: windowSize.width > 1200 ? "24px" : "20px",
                    fontWeight: "600",
                    mb: "10px",
                    children: t("noah339")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (index_module_default()).tips,
                    children: t("noah352")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).topBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((index_module_default()).period, " flex flexb"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flexc",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/all/vote.png",
                                            alt: "",
                                            className: (index_module_default()).voteImg
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).name,
                                            children: [
                                                "Epoch ",
                                                epoch
                                            ]
                                        })
                                    ]
                                }),
                                epoch && Number(epoch) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).btn, " flexc"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/vote/history",
                                            children: t("noah367")
                                        }),
                                        "\xa0>"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((index_module_default()).infos, " flex flexb"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).info, " flex flexcol"),
                                    onClick: function() {
                                        setShowPanel(!showPanel);
                                    // console.log(showPanel)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (index_module_default()).label,
                                            children: t("noah354")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).val,
                                            children: [
                                                (0,formatTimestamp/* default */.Z)(startTime / 1000, windowSize.width > 1200 ? 2 : 3),
                                                "-",
                                                (0,formatTimestamp/* default */.Z)(endTime / 1000, windowSize.width > 1200 ? 2 : 3),
                                                windowSize.width < 1200 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                                                        color: "#14162A",
                                                        toggled: !showPanel
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (showPanel || windowSize.width > 1200) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).info, " flex flexcol"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (index_module_default()).label,
                                            children: t("noah355")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).val,
                                            children: [
                                                staked,
                                                " NOAH"
                                            ]
                                        })
                                    ]
                                }),
                                (showPanel || windowSize.width > 1200) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).info, " flex flexcol"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (index_module_default()).label,
                                            children: t("noah356")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (index_module_default()).val,
                                            children: [
                                                amount,
                                                " ",
                                                t("noah357")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((index_module_default()).tools, " flex flexb"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((index_module_default()).myVotes, " flex flexc"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flexc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((index_module_default()).label),
                                        children: [
                                            t("noah359"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((index_module_default()).val),
                                        children: (0,formatBalance/* getRes */.sR)(myVotes, 4)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((index_module_default()).btn, " flexc pointer"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pledge",
                                        children: t("noah360")
                                    }),
                                    "\xa0>"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).table,
                    children: [
                        windowSize.width > 1200 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((index_module_default()).header, " flex flexb"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).one,
                                    children: t("noah286")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).two,
                                    children: t("noah361")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).three, " flex flexend"),
                                    children: [
                                        t("noah324"),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                            type: "info",
                                            text: t("noah394"),
                                            placement: "top-start",
                                            ml: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).four, " flex flexend"),
                                    children: [
                                        t("noah325"),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                            type: "info",
                                            text: t("noah393"),
                                            placement: "top-start",
                                            ml: "0"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).five,
                                    children: t("noah255")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).six, " flex flexc flexend"),
                                    children: [
                                        t("noah366"),
                                        "%\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                            type: "info",
                                            text: t("noah364"),
                                            placement: "top-start",
                                            ml: "0"
                                        })
                                    ]
                                })
                            ]
                        }),
                        windowSize.width > 1200 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).body,
                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableLoader, {}) : (list === null || list === void 0 ? void 0 : list.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((index_module_default()).list),
                                children: list.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((index_module_default()).item, " flexb"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).one, " flex flexc flexstart"),
                                                children: [
                                                    item.price_direction == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                        token0: item.token1,
                                                        token1: item.token0,
                                                        size: 30
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                        token0: item.token0,
                                                        token1: item.token1,
                                                        size: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex flexc",
                                                        style: {
                                                            marginLeft: "30px"
                                                        },
                                                        children: item.price_direction == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((index_module_default()).symbol0Name),
                                                            children: [
                                                                item.symbol1,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "".concat((index_module_default()).symbol1Name),
                                                                    children: [
                                                                        "/",
                                                                        item.symbol0
                                                                    ]
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "".concat((index_module_default()).symbol0Name),
                                                            children: [
                                                                item.symbol0,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "".concat((index_module_default()).symbol1Name),
                                                                    children: [
                                                                        "/",
                                                                        item.symbol1
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            Number(item.weight) >= 0.01 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).two, " flex flexcol flexjc"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: (0,formatBalance/* truncateZero */.bW)(item.weight, 2)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (index_module_default()).small,
                                                        children: [
                                                            (0,formatBalance/* truncateZero */.bW)(Number(item.proportion) * 100, 2),
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            Number(item.weight) > 0 && Number(item.weight) < 0.01 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).two, " flex flexcol flexjc"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "< 0.01"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_module_default()).small,
                                                        children: "0.00%"
                                                    })
                                                ]
                                            }),
                                            Number(item.weight) == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).two, " flex flexcol flexjc"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "0.00"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_module_default()).small,
                                                        children: "0.00%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((index_module_default()).three, " flex flexcol flexjc"),
                                                children: item.fee_sharing.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: item.fee_sharing.map(function(items, index_fee) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "",
                                                            children: (items === null || items === void 0 ? void 0 : items.quantity) != 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    (0,formatBalance/* truncateZero */.bW)(items === null || items === void 0 ? void 0 : items.quantity, 4),
                                                                    " ",
                                                                    items.symbol
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: index_fee == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: "-"
                                                                })
                                                            })
                                                        }, index_fee);
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((index_module_default()).four, " flex flexcol flexjc"),
                                                children: item.bribeList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: item.bribeList.map(function(items, index) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    (0,formatBalance/* formatEffectiveNumber */.bd)(items === null || items === void 0 ? void 0 : items.quantity),
                                                                    " ",
                                                                    items.symbol
                                                                ]
                                                            })
                                                        });
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((index_module_default()).five, " flex flexend"),
                                                children: item.total_yield > 0.01 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "$ ",
                                                        (0,formatBalance/* truncateZero */.bW)(item.total_yield, 2)
                                                    ]
                                                }) : item.total_yield == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "$ 0.00"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "$ < 0.01"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).six, " flex flexend"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((index_module_default()).sign, " ").concat((index_module_default()).sign_redu),
                                                        onClick: function() {
                                                            return handleVote(item, false);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/all/redu.png",
                                                            alt: "",
                                                            className: (index_module_default()).reduImg
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((index_module_default()).inputBox),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            disabled: true,
                                                            className: (index_module_default()).inputRate,
                                                            type: "text",
                                                            value: votes[item.id] !== undefined && votes[item.id] ? votes[item.id] + "%" : "",
                                                            onChange: handleSearchValue,
                                                            placeholder: t("0%")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "".concat((index_module_default()).sign, " ").concat((index_module_default()).sign_add),
                                                        onClick: function() {
                                                            if (totalVotes == 100) return;
                                                            handleVote(item, true);
                                                        },
                                                        style: {
                                                            cursor: totalVotes >= 100 ? "not-allowed" : "pointer",
                                                            opacity: totalVotes >= 100 ? 0.5 : 1
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/images/all/ad.png",
                                                            alt: "",
                                                            className: (index_module_default()).adImg
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "500px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/claim/nodata.png",
                                        width: 100,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        textAlign: "center",
                                        maxWidth: "400px",
                                        fontSize: "16px",
                                        mt: "16px",
                                        color: "#85868A",
                                        children: t("noah116")
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).body,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((index_module_default()).list),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((index_module_default()).header, " flex flexb"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).one,
                                                children: t("noah286")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).two,
                                                children: t("noah361")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (index_module_default()).three,
                                                children: t("noah255")
                                            })
                                        ]
                                    }),
                                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableLoader, {}) : (list === null || list === void 0 ? void 0 : list.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: list.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).item, " flexb"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((index_module_default()).data, " flexb"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((index_module_default()).one, " flex flexc flexstart"),
                                                                children: [
                                                                    item.price_direction == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                                        token0: item.token1,
                                                                        token1: item.token0,
                                                                        size: 24
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                                                                        token0: item.token0,
                                                                        token1: item.token1,
                                                                        size: 24
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex flexc",
                                                                        style: {
                                                                            marginLeft: "15px"
                                                                        },
                                                                        children: item.price_direction == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((index_module_default()).symbol0Name),
                                                                            children: [
                                                                                item.symbol1,
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "".concat((index_module_default()).symbol1Name),
                                                                                    children: [
                                                                                        "/",
                                                                                        item.symbol0
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "".concat((index_module_default()).symbol0Name),
                                                                            children: [
                                                                                item.symbol0,
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "".concat((index_module_default()).symbol1Name),
                                                                                    children: [
                                                                                        "/",
                                                                                        item.symbol1
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            Number(item.weight) >= 0.01 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((index_module_default()).two, " flex flexcol flexjc"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: (0,formatBalance/* truncateZero */.bW)(item.weight, 2)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (index_module_default()).small,
                                                                        children: [
                                                                            (0,formatBalance/* truncateZero */.bW)(Number(item.proportion) * 100, 2),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            Number(item.weight) > 0 && Number(item.weight) < 0.01 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((index_module_default()).two, " flex flexcol flexjc"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: "< 0.01"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (index_module_default()).small,
                                                                        children: "0.00%"
                                                                    })
                                                                ]
                                                            }),
                                                            Number(item.weight) == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((index_module_default()).two, " flex flexcol flexjc"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: "0.00"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (index_module_default()).small,
                                                                        children: "0.00%"
                                                                    })
                                                                ]
                                                            }),
                                                            item.total_yield > 0.01 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((index_module_default()).three, " flex flexend"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flexc pointer",
                                                                    onClick: function() {
                                                                        openModalWithItem(item);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            children: [
                                                                                "$ ",
                                                                                (0,formatBalance/* truncateZero */.bW)(item.total_yield, 2)
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/images/all/menu.png",
                                                                            alt: "",
                                                                            className: "".concat((index_module_default()).lpImg)
                                                                        })
                                                                    ]
                                                                })
                                                            }) : item.total_yield == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((index_module_default()).three, " flex flexend"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flexc pointer",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "$ 0.00"
                                                                    })
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((index_module_default()).three, " flex flexend"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flexc pointer",
                                                                    onClick: function() {
                                                                        openModalWithItem(item);
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "$ < 0.01"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/images/all/menu.png",
                                                                            alt: "",
                                                                            className: "".concat((index_module_default()).lpImg)
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((index_module_default()).go, " flex flexb"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((index_module_default()).label),
                                                                children: t("noah366")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "".concat((index_module_default()).six, " flex flexend"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "".concat((index_module_default()).sign, " ").concat((index_module_default()).sign_redu),
                                                                        onClick: function() {
                                                                            return handleVote(item, false);
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/images/all/redu.png",
                                                                            alt: "",
                                                                            className: (index_module_default()).reduImg
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "".concat((index_module_default()).inputBox),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            disabled: true,
                                                                            className: (index_module_default()).inputRate,
                                                                            type: "text",
                                                                            value: votes[item.id] !== undefined && votes[item.id] ? votes[item.id] + "%" : "",
                                                                            onChange: handleSearchValue,
                                                                            placeholder: t("0%")
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "".concat((index_module_default()).sign, " ").concat((index_module_default()).sign_add),
                                                                        onClick: function() {
                                                                            if (totalVotes == 100) return;
                                                                            handleVote(item, true);
                                                                        },
                                                                        style: {
                                                                            cursor: totalVotes >= 100 ? "not-allowed" : "pointer",
                                                                            opacity: totalVotes >= 100 ? 0.5 : 1
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/images/all/ad.png",
                                                                            alt: "",
                                                                            className: (index_module_default()).adImg
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "280px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/claim/nodata.png",
                                                width: 80,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                textAlign: "center",
                                                maxWidth: "400px",
                                                fontSize: "16px",
                                                mt: "16px",
                                                color: "#85868A",
                                                children: t("noah116")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((index_module_default()).last, " flex"),
                            children: [
                                windowSize.width > 1200 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((index_module_default()).allScore),
                                    children: [
                                        t("noah365"),
                                        ": ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                totalVotes ? totalVotes : "0.00",
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                account ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: windowSize.width > 1200 ? "flex flexb" : "",
                                    children: [
                                        reset === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((index_module_default()).reset_btn, " flexc pointer"),
                                            onClick: function() {
                                                handleReset();
                                            },
                                            children: t("noah607")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: windowSize.width > 1200 ? "auto" : "100%"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(noVotes || loading || state.totalVotes != 100 || (0,formatBalance/* getRes */.sR)(myVotes, 4) == 0 || reset === 0 || reset === 2 ? (index_module_default()).disabled_btn : (index_module_default()).go_vote, " flexc pointer"),
                                                style: {
                                                    cursor: noVotes || state.totalVotes != 100 || (0,formatBalance/* getRes */.sR)(myVotes, 4) == 0 || reset === 0 || reset === 2 ? "not-allowed" : "pointer"
                                                },
                                                onClick: function() {
                                                    if (state.totalVotes != 100 || noVotes || !account || (0,formatBalance/* getRes */.sR)(myVotes, 4) == 0 || reset === 0 || reset === 2) return;
                                                    onPresentVoteModal();
                                                },
                                                children: reset === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("noah436")
                                                }) : reset === 2 ? // 本记元已取消投票
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("noah609")
                                                }) : (reset === 1 || reset === 3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: state.totalVotes == 100 || state.totalVotes == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("noah366")
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("%num% voting rights unallocated", {
                                                            num: 100 - state.totalVotes + "%"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }) : // 连接钱包
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((index_module_default()).go_vote, " flexc pointer"),
                                    onClick: handleClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("noah366")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/vote/index.tsx
/* eslint-disable */ 

var VotePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Vote, {});
};
VotePage.Layout = VotePage;
/* harmony default export */ var vote = (Vote);


/***/ }),

/***/ 65044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ getAdd; },
/* harmony export */   "FH": function() { return /* binding */ toFixed; },
/* harmony export */   "Pn": function() { return /* binding */ getFullNum; },
/* harmony export */   "U1": function() { return /* binding */ formatBigNumberToFixed; },
/* harmony export */   "az": function() { return /* binding */ formatBalance; },
/* harmony export */   "b9": function() { return /* binding */ truncateHasZero; },
/* harmony export */   "bW": function() { return /* binding */ truncateZero; },
/* harmony export */   "bd": function() { return /* binding */ formatEffectiveNumber; },
/* harmony export */   "cy": function() { return /* binding */ getSub; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "m8": function() { return /* binding */ formatEffectiveNumberSix; },
/* harmony export */   "sR": function() { return /* binding */ getRes; },
/* harmony export */   "w$": function() { return /* binding */ formatFixedNumber; }
/* harmony export */ });
/* unused harmony exports getDecimalAmount, getBalanceAmount, getBalanceNumber, getFullDisplayBalance, formatNumber, formatBigNumber, formatLocalisedCompactNumber, formatLpBalance, truncate, formatEffectiveNumber2 */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61744);
/* harmony import */ var _noahswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65208);
/* harmony import */ var _getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44356);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74152);
/* harmony import */ var moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33730);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ko__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable */ 






 // 中文繁体
 // 韩文
// 加法函数
function getAdd(a, b) {
    var num1 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(a);
    var num2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(b);
    return num1.plus(num2).toString();
}
// 减法函数
function getSub(a, b) {
    var num1 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(a);
    var num2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(b);
    return num1.minus(num2).toString();
}
function getTime(value) {
    return moment__WEBPACK_IMPORTED_MODULE_3___default()(value).format("YYYY-MM-DD HH:mm:ss");
//   const zone = moment().utcOffset() / 60; // 时区
//   const formattedTime = moment(value).add(0 + zone, 'hours');
//   const codeFromStorage = getLanguageCodeFromLS() // current language code
//   // console.log('当前缓存的语言', codeFromStorage)
//   if (codeFromStorage === 'zh-TW') {
//     formattedTime.locale('zh-tw');
//     // return formattedTime.format("MMMDo, A hh:mm, dddd");
//     return formattedTime.format("YYYY年MMMD Ah:mm");
//   } else if (codeFromStorage === 'ko-KR') {
//     formattedTime.locale('ko');
//     // return formattedTime.format("hh:mm A, dddd, MMM D");
//     return formattedTime.format("hh:mm A, YYYY MMM D");
//   } else {
//     formattedTime.locale('en');
//     // return formattedTime.format("hh:mm A, ddd, MMM D");
//     return formattedTime.format("MMM D, YYYY, h:mm A");
//   }
//   // return moment(time).add(0 + zone, 'hours').format("hh:mm A, dddd, MMM. D")
// // },
// // return moment(value).format('MMM D, YYYY, h:mm A')
}
function formatBalance(price, precision) {
    var realPrice = formatBigNumber(price);
    var scaledPrice = Number(realPrice) * Math.pow(10, 18);
    var formattedPrice = (scaledPrice / Math.pow(10, precision)).toFixed(precision);
    return formattedPrice;
}
/**
 * Take a formatted amount, e.g. 15 EOS and convert it to full decimal value, e.g. 15000000000000000
 */ var getDecimalAmount = function(amount) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return new BigNumber(amount).times(getFullDecimalMultiplier(decimals));
};
var getBalanceAmount = function(amount) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return new BigNumber(amount).dividedBy(getFullDecimalMultiplier(decimals));
};
/**
 * This function is not really necessary but is used throughout the site.
 */ var getBalanceNumber = function(balance) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return getBalanceAmount(balance, decimals).toNumber();
};
var getFullDisplayBalance = function(balance) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, displayDecimals = arguments.length > 2 ? arguments[2] : void 0;
    return getBalanceAmount(balance, decimals).toFixed(displayDecimals);
};
/**
 * Don't use the result to convert back to number.
 * It uses undefined locale which uses host language as a result.
 * Languages have different decimal separators which results in inconsistency when converting back this result to number.
 */ var formatNumber = function(number) {
    var minPrecision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, maxPrecision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var options = {
        minimumFractionDigits: minPrecision,
        maximumFractionDigits: maxPrecision
    };
    return number.toLocaleString(undefined, options);
};
/**
 * Method to format the display of wei given an EthersBigNumber object
 * Note: does NOT round
 */ var formatBigNumber = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    var remainder = number.mod(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__/* .BigNumber.from */ .O$.from(10).pow(decimals - displayDecimals));
    return (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_7__.formatUnits)(number.sub(remainder), decimals);
};
/**
 * Method to format the display of wei given an EthersBigNumber object with toFixed
 * Note: rounds
 */ var formatBigNumberToFixed = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    var formattedString = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_7__.formatUnits)(number, decimals);
    return (+formattedString).toFixed(displayDecimals);
};
/**
 * Formats a FixedNumber like BigNumber
 * i.e. Formats 9763410526137450427.1196 into 9.763 (3 display decimals)
 */ var formatFixedNumber = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    // Remove decimal
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(number.toString().split("."), 1), leftSide = ref[0];
    return formatBigNumber(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__/* .BigNumber.from */ .O$.from(leftSide), displayDecimals, decimals);
};
var formatLocalisedCompactNumber = function(number) {
    var codeFromStorage = getLanguageCodeFromLS();
    var isClient = "object" === "object";
    var isSupported = window === null || window === void 0 ? void 0 : window.Intl;
    // For clients do not support Intl, just return number
    if (isClient && !isSupported) {
        return "".concat(number);
    }
    return new Intl.NumberFormat(codeFromStorage, {
        notation: "compact",
        compactDisplay: "long",
        maximumSignificantDigits: 2
    }).format(number);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (formatLocalisedCompactNumber)));
var formatLpBalance = function(balance) {
    var stakedBalanceBigNumber = getBalanceAmount(balance);
    if (stakedBalanceBigNumber.gt(0) && stakedBalanceBigNumber.lt(0.00001)) {
        return "< 0.00001";
    }
    return stakedBalanceBigNumber.toFixed(5, BigNumber.ROUND_DOWN);
};
// 截取，只保留有效位数
var truncate = function(num, decimals) {
    var multiplier = Math.pow(10, decimals);
    return Math.floor(num * multiplier) / multiplier;
};
// 截取，包含0
var truncateZero = function(num, decimals) {
    var str = num.toString();
    var index = str.indexOf(".");
    if (index >= 0) {
        var mainPart = str.slice(0, index);
        var decimalPart = str.slice(index + 1, index + 1 + decimals);
        return mainPart + "." + decimalPart.padEnd(decimals, "0");
    } else {
        return str + "." + "0".repeat(decimals);
    }
};
// 截取有效位数，从小数部分非零数字开始计数
var truncateHasZero = function(num, decimals) {
    var str = num.toString();
    var index = str.indexOf(".");
    if (index >= 0) {
        var mainPart = str.slice(0, index);
        var decimalPart = str.slice(index + 1);
        var nonZeroIndex = 0;
        while(nonZeroIndex < decimalPart.length && decimalPart[nonZeroIndex] === "0"){
            nonZeroIndex++;
        }
        var truncatedDecimalPart = decimalPart.slice(0, nonZeroIndex + decimals);
        return mainPart + "." + truncatedDecimalPart;
    } else {
        return str;
    }
};
// 返回3位或指定有效位小数，例如：200.000输出200，200.000123输出200.000123
var formatEffectiveNumber = function(num) {
    var n = Number(num);
    var str = n.toString();
    var decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1 && str.length > decimalIndex + 4) {
        return str.slice(0, decimalIndex + 4);
    } else {
        return str;
    }
};
var formatEffectiveNumberSix = function(decimal) {
    var decimalString = decimal.toString();
    var match = decimalString.match(/^0\.0*([1-9]\d{0,5})/);
    if (match) {
        return match[0];
    } else {
        return Number(decimal).toPrecision(8);
    }
};
var formatEffectiveNumber2 = function(num, decimal) {
    var str = num.toString();
    var decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1) {
        var decimals = str.slice(decimalIndex + 1);
        var nonZeroIndex = decimals.search(/[^0]/) //查找第一个非零小数的位置
        ;
        if (nonZeroIndex !== -1) {
            //保留指定有效位数的小数
            var effectiveDecimals = decimals.slice(nonZeroIndex, nonZeroIndex + decimal);
            return str.slice(0, decimalIndex + 1) + effectiveDecimals;
        }
    }
    return str;
};
// 取消四舍五入
var getRes = function(num) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    // if (Number(num) === Math.floor(num)) return Math.floor(num);
    var res = [];
    var addNum = 0;
    // eslint-disable-next-line no-param-reassign
    num += "";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(num.split("."), 2), zs = ref[0], xs = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(/^(-?)(\d+\.\d+|\d+)$/.exec(zs), 3), symbol = ref1[1], zsNum = ref1[2];
    if (!xs) return num;
    for(var i = 0; i < xs.length; i++){
        var ele = xs[i];
        // eslint-disable-next-line
        if (ele != 0) {
            // if (xs[i + digit] && xs[i + digit] > 4) {
            //   addNum = 1
            //   for (let j = i + (digit - 1); j >= 0; j--) {
            //     if (Number(xs[j]) + addNum === 10) res[j] = '0'
            //     else {
            //       res[j] = Number(xs[j]) + addNum
            //       addNum = 0
            //     }
            //   }
            // } else {
            for(var k = i; k <= i + (digit - 1); k++){
                res[k] = xs[k];
            }
            break;
        } else res[i] = xs[i];
    }
    return getFullNum(Number("".concat(symbol + (Number(zsNum) + addNum), ".").concat(res.join(""))));
};
var getFullNum = function(num) {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        return num;
    }
    // 处理不需要转换的数字
    var str = String(num);
    if (!/e/i.test(str)) {
        return num;
    }
    return Number(num).toFixed(18).replace(/\.?0+$/, "");
};
var toFixed = function(value, precision) {
    var numberValue = Number(value);
    return numberValue.toFixed(precision);
};


/***/ }),

/***/ 63257:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function formatTimestamp(timestamp) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!timestamp) return "-";
    var date = new Date(timestamp * 1000);
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    var hours = String(date.getHours()).padStart(2, "0");
    var minutes = String(date.getMinutes()).padStart(2, "0");
    var formattedDate;
    if (type === 1) {
        formattedDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes);
    } else if (type === 2) {
        formattedDate = "".concat(year, "/").concat(month, "/").concat(day, " ").concat(hours, ":").concat(minutes);
    } else if (type === 3) {
        formattedDate = "".concat(month, "/").concat(day, " ").concat(hours, ":").concat(minutes);
    } else if (type === 4) {
        formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
    } else {
        throw new Error("Invalid type");
    }
    return formattedDate;
}
/* harmony default export */ __webpack_exports__["Z"] = (formatTimestamp);


/***/ }),

/***/ 42808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ transactionErrorToUserReadableMessage; }
/* harmony export */ });
/* eslint-disable */ /**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 * @param t Translation function
 * @param page
 */ function transactionErrorToUserReadableMessage(error, t, page) {
    var reason;
    while(error){
        var ref, ref1;
        var _reason, ref2, ref3, ref4;
        reason = (ref4 = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : error) !== null && ref4 !== void 0 ? ref4 : reason;
        var _error;
        // eslint-disable-next-line no-param-reassign
        error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("cancel")) === 0) {
        return "user rejected transaction";
    }
    if (page === "bridge") {
        if (reason == undefined) {
            return "An unknown RPC erroroccurred.";
        }
        if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("user rejected transaction")) === 0) {
            console.log("user rejected");
            return "user rejected transaction";
        }
        var dataMatch = /"data":\s*{[^}]*"message":\s*"([^"]*)"/.exec(reason);
        if (dataMatch && dataMatch[1]) {
            var dataMessage = dataMatch[1];
            // console.log(dataMessage);
            return dataMessage;
        }
        return reason;
    } else {
        switch(reason){
            case "NoahRouter: EXPIRED":
                return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
            case "NoahRouter: INSUFFICIENT_OUTPUT_AMOUNT":
            case "NoahRouter: EXCESSIVE_INPUT_AMOUNT":
            case "NoahRouter: INSUFFICIENT_A_AMOUNT":
            case "NoahRouter: INSUFFICIENT_B_AMOUNT":
                return t("This transaction will not succeed either due to price movement or fee on transfer.");
            case "TransferHelper: TRANSFER_FROM_FAILED":
                return t("The input token cannot be transferred. There may be an issue with the input token.");
            case "Noah: TRANSFER_FAILED":
                return t("The output token cannot be transferred. There may be an issue with the output token.");
            default:
                if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                    console.error(error, reason);
                    if (page === "swap") {
                        return t("An error occurred when trying to execute this operation. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
                    } else {
                        return t("An error occurred when trying to execute this operation.");
                    }
                }
                return t("%reason%.", {
                    reason: reason ? ': "'.concat(reason, '"') : ""
                });
        }
    }
}


/***/ }),

/***/ 60764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ CurrencyLogo; },
  "g": function() { return /* binding */ DoubleCurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/LogoLoader.tsx





var BAD_SRCS = [];
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback to HelpIcon
 */ var LogoLoader = function(_param) {
    var src = _param.src, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    var ref = (0,react.useState)(0), refresh = ref[1];
    var srcFailedLoading = BAD_SRCS.includes(src);
    if (src && !srcFailedLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS.push(src);
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ var CurrencyLogo_LogoLoader = (LogoLoader);

;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx
/* eslint-disable */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */\n  background-color: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(CurrencyLogo_LogoLoader).withConfig({
    componentId: "sc-1182136a-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg && "-6px";
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg ? "4" : "3";
});
var CurrencyLogo = function(_param) {
    var address = _param.address, symbol = _param.symbol, _size = _param.size, size = _size === void 0 ? "24px" : _size, _firstimg = _param.firstimg, firstimg = _firstimg === void 0 ? "false" : _firstimg, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "address",
        "symbol",
        "size",
        "firstimg"
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var src = (0,react.useMemo)(function() {
        // const checksummedAddress = isAddress(address)
        if (address && symbol) {
            // return `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${checksummedAddress}/logo.png`
            // return `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
            return "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/".concat(chainId, "-").concat(address.toLowerCase(), "-").concat(symbol.toLowerCase(), ".png");
        }
        return null;
    }, [
        address,
        symbol,
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, (0,_object_spread/* default */.Z)({
        size: size,
        src: src,
        alt: "token logo",
        firstimg: firstimg
    }, rest));
};
var DoubleCurrencyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1182136a-1"
})(_templateObject1());
var DoubleCurrencyLogo = function(param) {
    var token0 = param.token0, token1 = param.token1, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoubleCurrencyWrapper, {
        children: [
            (token0 === null || token0 === void 0 ? void 0 : token0.address) && (token0 === null || token0 === void 0 ? void 0 : token0.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token0 === null || token0 === void 0 ? void 0 : token0.address,
                symbol: token0 === null || token0 === void 0 ? void 0 : token0.symbol,
                size: "".concat(size.toString(), "px"),
                firstimg: "true"
            }),
            (token1 === null || token1 === void 0 ? void 0 : token1.address) && (token1 === null || token1 === void 0 ? void 0 : token1.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token1 === null || token1 === void 0 ? void 0 : token1.address,
                symbol: token1 === null || token1 === void 0 ? void 0 : token1.symbol,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
};


/***/ }),

/***/ 53710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"symbol1Name":"all_symbol1Name__dTEsE","one":"all_one__SI86F","twoBox":"all_twoBox__YQomq","test":"all_test__2zDIn","label":"all_label__ZHhhk","two":"all_two__a99s_","tips":"all_tips__s1qi6","list2":"all_list2__D6Bhr","box":"all_box__56oha","item":"all_item__5LmxO","tit":"all_tit__oRg0v","symbol0Name":"all_symbol0Name__vqvO2","rate":"all_rate__MSCqr","details":"all_details__62Im7","btn":"all_btn__5kP3P"};

/***/ }),

/***/ 81528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lg_farms":"style_lg_farms__U9xbn","table":"style_table__EkLWj","header":"style_header__sRmzv","one":"style_one__TIjOR","two":"style_two__iz1fQ","body":"style_body__vj5s5","three":"style_three__Og5_I","four":"style_four__7VFM9","five":"style_five__l152E","six":"style_six__ftEGd","adImg":"style_adImg__F6Yo_","reduImg":"style_reduImg__uN2wa","tips":"style_tips__Nujvn","topBox":"style_topBox__q3q7x","voteImg":"style_voteImg__iRkez","name":"style_name__fFWNp","time":"style_time__qOqer","btn":"style_btn__qeZYD","infos":"style_infos__kS7Pe","info":"style_info__92bdi","label":"style_label__iKk28","val":"style_val__sZmEh","tools":"style_tools__2zXFX","searchBox":"style_searchBox__DHvd5","img":"style_img__5r96e","input":"style_input__IxXGk","clean":"style_clean__CX4nq","last":"style_last__gcdeW","allScore":"style_allScore__xEssl","reset_btn":"style_reset_btn___ch7P","go_vote":"style_go_vote__NZ39e","go_vote2":"style_go_vote2__VDh9i","symbol1Name":"style_symbol1Name__82NsE","small":"style_small__ko78Z","item":"style_item__1hlCD","btn2":"style_btn2__IfMQf","sign":"style_sign__s_bNu","sign_redu":"style_sign_redu__oX9vR","sign_add":"style_sign_add__SkUsh","inputBox":"style_inputBox__Dmq1x","inputRate":"style_inputRate__u3ftg","sm_farms":"style_sm_farms__SE49X","myVotes":"style_myVotes__0mUeJ","data":"style_data__m6GRV","go":"style_go__UIYic","lpImg":"style_lpImg__B9ETr","disabled_btn":"style_disabled_btn__AHL68","test":"style_test__8etGE","bigBox":"style_bigBox__lu1fg","bigBox_small":"style_bigBox_small__0igfo"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,9774,2888,179], function() { return __webpack_exec__(75125); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);